import auth from './api/auth'
import home from './api/home'
import opus from './api/opus'
import brochure from './api/brochure'
import product from './api/product'
import spread from './api/spread'
import trade from './api/trade'
import user from './api/user'
import file from './api/file'
export default {
  auth,
  home,
  opus,
  brochure,
  product,
  spread,
  trade,
  user,
  file
}



// WEBPACK FOOTER //
// ./src/config/api.js